const PLAN_PRIORITY = [
  ['is_platinum_user', 'Platinum'],
  ['is_gold_user', 'Oro'],
  ['is_silver_user', 'Plata'],
  ['is_bronze_user', 'Bronce'],
  ['is_basic_user', 'Básico']
];

export function modernAccountIdentity(user = {}) {
  const name = String(user.name || user.username || user.display_name || '').trim() || 'Mi cuenta';
  const words = name.split(/\s+/).filter(Boolean);
  const initials = words.slice(0, 2).map(word => word.charAt(0).toUpperCase()).join('') || 'EU';
  const plan = PLAN_PRIORITY.find(([field]) => user[field] === true || user[field] === 1 || user[field] === '1');

  return { name, initials, plan: plan ? plan[1] : '' };
}
